import { render } from "./Iempty.vue?vue&type=template&id=115095b3&scoped=true"
const script = {}

import "./Iempty.vue?vue&type=style&index=0&id=115095b3&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115095b3"]])

export default __exports__